import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { Form, Col, Row, Button, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { setBaseProductInitialStock } from './actions'

function ProductStock(props) {
    const [initialStock, initStock] = useState(false)

    return <div>
        <p className="lead mb-2">
            Estoque {!initialStock ? <span className="badge badge-primary">( Produto sem estoque )</span> : null}
        </p>
        {
            initialStock ? <Form.Group>
                <Form.Label>
                    Estoque inicial
                </Form.Label>
                <Form.Control
                    className="mb-1"
                    value={props.stock}
                    type="number"
                    placeholder="Quantidade inicial"
                    onChange={e => {
                        if(Number(e.target.value <= 0)) {
                            props.setBaseProductInitialStock(0)    
                        } else {
                            props.setBaseProductInitialStock(e.target.value) 
                        }
                    }} />
                <Button 
                size='sm'
                onClick={e => {
                    props.setBaseProductInitialStock("")
                    initStock(false)
                }}>
                    Cancelar
                </Button>
            </Form.Group>
                : <Button onClick={e => {
                    initStock(true)
                }}>
                    Iniciar Estoque
</Button>
        }


    </div>
}

const mapStateToProps = state => ({
    stock: state.initialStock
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setBaseProductInitialStock
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProductStock)


// WEBPACK FOOTER //
// ./src/components/pages/products/base/stock.jsx